module.exports = __webpack_public_path__ + "img/soundcloud_logo.66ffdb1e.png";